import { render, staticRenderFns } from "./newJy.vue?vue&type=template&id=01fc4a81&scoped=true&"
import script from "./newJy.vue?vue&type=script&lang=js&"
export * from "./newJy.vue?vue&type=script&lang=js&"
import style0 from "./newJy.vue?vue&type=style&index=0&id=01fc4a81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fc4a81",
  null
  
)

export default component.exports